import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { Outlet } from "react-router-dom";

const PublicLayout = ({ children }) => {
  return (
    <div
      className="
      min-h-screen
      bg-white
      text-gray-800
    "
    >
      <Navbar />

      <main>
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export default PublicLayout;
